export default "__VITE_ASSET__bsRIL61J__"